// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.value_your_trade_card[data-v-5f04e1c0] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.custom_legend[data-v-5f04e1c0] {
  position: absolute;
  display: inline-block;
  background: #fff;
  z-index: 9;
  font-size: 12px;
  top: -12px;
  left: 30px;
  padding: 0 6px;
  color: #000;
  opacity: 0.8;
}
.card_font_sizes h5[data-v-5f04e1c0] {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.card_font_sizes p[data-v-5f04e1c0] {
  margin-bottom: 3px;
  font-size: 11px;
  white-space: initial;
}
.min-120[data-v-5f04e1c0] {
  min-height: 65px;
}
.brake_word span[data-v-5f04e1c0] {
  word-break: break-word;
  display: inline-block;
}
.my_current_vehicle .car_info[data-v-5f04e1c0] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.my_current_vehicle .car_info img[data-v-5f04e1c0] {
  height: 50px;
  margin: auto;
  display: block;
  object-fit: contain;
}
.my_current_vehicle .car_info h5[data-v-5f04e1c0] {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.my_current_vehicle .car_info p[data-v-5f04e1c0] {
  margin-bottom: 3px;
  font-size: 11px;
  white-space: initial;
}
.my_current_vehicle .my_upgrade_vehicle[data-v-5f04e1c0] {
  padding: 1px !important;
}
.car_icon i[data-v-5f04e1c0] {
  font-size: 30px;
  opacity: 0.6;
}
@-webkit-keyframes flipInX-5f04e1c0 {
0% {
    -webkit-transform: perspective(400px) rotateX(90deg);
    transform: perspective(400px) rotateX(90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
}
40% {
    -webkit-transform: perspective(400px) rotateX(-20deg);
    transform: perspective(400px) rotateX(-20deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
}
60% {
    -webkit-transform: perspective(400px) rotateX(10deg);
    transform: perspective(400px) rotateX(10deg);
    opacity: 1;
}
80% {
    -webkit-transform: perspective(400px) rotateX(-5deg);
    transform: perspective(400px) rotateX(-5deg);
}
to {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
}
}
@keyframes flipInX-5f04e1c0 {
0% {
    -webkit-transform: perspective(400px) rotateX(90deg);
    transform: perspective(400px) rotateX(90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
}
40% {
    -webkit-transform: perspective(400px) rotateX(-20deg);
    transform: perspective(400px) rotateX(-20deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
}
60% {
    -webkit-transform: perspective(400px) rotateX(10deg);
    transform: perspective(400px) rotateX(10deg);
    opacity: 1;
}
80% {
    -webkit-transform: perspective(400px) rotateX(-5deg);
    transform: perspective(400px) rotateX(-5deg);
}
to {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
}
}
.animate__flipInX[data-v-5f04e1c0] {
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
  -webkit-animation-name: flipInX-5f04e1c0;
  animation-name: flipInX-5f04e1c0;
}
.flipInX[data-v-5f04e1c0] {
  animation: flipInX-5f04e1c0 2s;
}
.animate_bottom[data-v-5f04e1c0] {
  animation: animateBottom-5f04e1c0 2s;
  transition: 0.5s;
}
@keyframes animateBottom-5f04e1c0 {
0% {
    transform: translateY(50px);
}
100% {
    transform: translateY(0);
}
}
@media (min-width: 1900px) {
.my_current_vehicle .car_info h5[data-v-5f04e1c0] {
    font-size: 13px;
}
.my_current_vehicle .car_info p[data-v-5f04e1c0] {
    font-size: 12px;
}
.custom_legend[data-v-5f04e1c0] {
    font-size: 13px;
}
.car_icon i[data-v-5f04e1c0] {
    font-size: 30px;
}
}
@media (min-width: 2500px) {
.my_current_vehicle .car_info h5[data-v-5f04e1c0] {
    font-size: 16px;
}
.my_current_vehicle .car_info p[data-v-5f04e1c0] {
    font-size: 14px;
}
.custom_legend[data-v-5f04e1c0] {
    font-size: 16px;
}
.car_icon i[data-v-5f04e1c0] {
    font-size: 30px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/SlideOutPanel/TvmMyVehicle/TvmMyVehicle.vue","webpack://./TvmMyVehicle.vue"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;ACDF;ADIA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;ACFF;ADKA;EAEI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;ACJJ;ADFA;EAUI,kBAAA;EACA,eAAA;EACA,oBAAA;ACLJ;ADSA;EACE,gBAAA;ACPF;ADUA;EACE,sBAAA;EACA,qBAAA;ACRF;ADYA;EA5CE,sBAAA;EACA,mBAAA;EACA,YAAA;ACmCF;ADOA;EAKM,YAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;ACTN;ADCA;EAxBI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;AC0BJ;ADNA;EAhBI,kBAAA;EACA,eAAA;EACA,oBAAA;ACyBJ;ADGE;EACE,uBAAA;ACDJ;ADKA;EACE,eAAA;EACA,YAAA;ACHF;ADMA;AACE;IACE,oDAAA;IACA,4CAAA;IACA,0CAAA;IACA,kCAAA;IACA,UAAA;ACJF;ADOA;IACE,qDAAA;IACA,6CAAA;IACA,0CAAA;IACA,kCAAA;ACLF;ADQA;IACE,oDAAA;IACA,4CAAA;IACA,UAAA;ACNF;ADSA;IACE,oDAAA;IACA,4CAAA;ACPF;ADUA;IACE,qCAAA;IACA,6BAAA;ACRF;AACF;ADWA;AACE;IACE,oDAAA;IACA,4CAAA;IACA,0CAAA;IACA,kCAAA;IACA,UAAA;ACTF;ADYA;IACE,qDAAA;IACA,6CAAA;IACA,0CAAA;IACA,kCAAA;ACVF;ADaA;IACE,oDAAA;IACA,4CAAA;IACA,UAAA;ACXF;ADcA;IACE,oDAAA;IACA,4CAAA;ACZF;ADeA;IACE,qCAAA;IACA,6BAAA;ACbF;AACF;ADgBA;EACE,+CAAA;EACA,uCAAA;EACA,wCAAA;EACA,gCAAA;ACdF;ADiBA;EACE,8BAAA;ACfF;ADkBA;EACE,oCAAA;EACA,gBAAA;AChBF;ADmBA;AACE;IACE,2BAAA;ACjBF;ADoBA;IACE,wBAAA;AClBF;AACF;ADqBA;AACE;IAEI,eAAA;ACpBJ;ADkBA;IAMI,eAAA;ACrBJ;ADyBA;IACE,eAAA;ACvBF;AD0BA;IACE,eAAA;ACxBF;AACF;AD2BA;AACE;IAEI,eAAA;AC1BJ;ADwBA;IAMI,eAAA;AC3BJ;AD+BA;IACE,eAAA;AC7BF;ADgCA;IACE,eAAA;AC9BF;AACF","sourcesContent":["\n// reuseable css\n.value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n\n.card_font_sizes {\n  h5 {\n    font-size: 12px;\n    font-weight: 600;\n    color: #000;\n    white-space: initial;\n    margin: 0;\n  }\n\n  p {\n    margin-bottom: 3px;\n    font-size: 11px;\n    white-space: initial;\n  }\n}\n\n.min-120 {\n  min-height: 65px;\n}\n\n.brake_word span {\n  word-break: break-word;\n  display: inline-block;\n}\n\n// end reuseable css\n.my_current_vehicle {\n  .car_info {\n    .value_your_trade_card();\n\n    img {\n      height: 50px;\n      margin: auto;\n      display: block;\n      object-fit: contain;\n    }\n\n    .card_font_sizes();\n  }\n\n  & .my_upgrade_vehicle {\n    padding: 1px !important;\n  }\n}\n\n.car_icon i {\n  font-size: 30px;\n  opacity: 0.6;\n}\n\n@-webkit-keyframes flipInX {\n  0% {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    -webkit-transform: perspective(400px) rotateX(-20deg);\n    transform: perspective(400px) rotateX(-20deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    -webkit-transform: perspective(400px) rotateX(10deg);\n    transform: perspective(400px) rotateX(10deg);\n    opacity: 1;\n  }\n\n  80% {\n    -webkit-transform: perspective(400px) rotateX(-5deg);\n    transform: perspective(400px) rotateX(-5deg);\n  }\n\n  to {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n}\n\n@keyframes flipInX {\n  0% {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    -webkit-transform: perspective(400px) rotateX(-20deg);\n    transform: perspective(400px) rotateX(-20deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    -webkit-transform: perspective(400px) rotateX(10deg);\n    transform: perspective(400px) rotateX(10deg);\n    opacity: 1;\n  }\n\n  80% {\n    -webkit-transform: perspective(400px) rotateX(-5deg);\n    transform: perspective(400px) rotateX(-5deg);\n  }\n\n  to {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n}\n\n.animate__flipInX {\n  -webkit-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n  -webkit-animation-name: flipInX;\n  animation-name: flipInX;\n}\n\n.flipInX {\n  animation: flipInX 2s;\n}\n\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@media (min-width: 1900px) {\n  .my_current_vehicle .car_info {\n    h5 {\n      font-size: 13px;\n    }\n\n    p {\n      font-size: 12px;\n    }\n  }\n\n  .custom_legend {\n    font-size: 13px;\n  }\n\n  .car_icon i {\n    font-size: 30px;\n  }\n}\n\n@media (min-width: 2500px) {\n  .my_current_vehicle .car_info {\n    h5 {\n      font-size: 16px;\n    }\n\n    p {\n      font-size: 14px;\n    }\n  }\n\n  .custom_legend {\n    font-size: 16px;\n  }\n\n  .car_icon i {\n    font-size: 30px;\n  }\n}\n",".value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n.card_font_sizes h5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.card_font_sizes p {\n  margin-bottom: 3px;\n  font-size: 11px;\n  white-space: initial;\n}\n.min-120 {\n  min-height: 65px;\n}\n.brake_word span {\n  word-break: break-word;\n  display: inline-block;\n}\n.my_current_vehicle .car_info {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.my_current_vehicle .car_info img {\n  height: 50px;\n  margin: auto;\n  display: block;\n  object-fit: contain;\n}\n.my_current_vehicle .car_info h5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.my_current_vehicle .car_info p {\n  margin-bottom: 3px;\n  font-size: 11px;\n  white-space: initial;\n}\n.my_current_vehicle .my_upgrade_vehicle {\n  padding: 1px !important;\n}\n.car_icon i {\n  font-size: 30px;\n  opacity: 0.6;\n}\n@-webkit-keyframes flipInX {\n  0% {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    -webkit-transform: perspective(400px) rotateX(-20deg);\n    transform: perspective(400px) rotateX(-20deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n  60% {\n    -webkit-transform: perspective(400px) rotateX(10deg);\n    transform: perspective(400px) rotateX(10deg);\n    opacity: 1;\n  }\n  80% {\n    -webkit-transform: perspective(400px) rotateX(-5deg);\n    transform: perspective(400px) rotateX(-5deg);\n  }\n  to {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n}\n@keyframes flipInX {\n  0% {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    -webkit-transform: perspective(400px) rotateX(-20deg);\n    transform: perspective(400px) rotateX(-20deg);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in;\n  }\n  60% {\n    -webkit-transform: perspective(400px) rotateX(10deg);\n    transform: perspective(400px) rotateX(10deg);\n    opacity: 1;\n  }\n  80% {\n    -webkit-transform: perspective(400px) rotateX(-5deg);\n    transform: perspective(400px) rotateX(-5deg);\n  }\n  to {\n    -webkit-transform: perspective(400px);\n    transform: perspective(400px);\n  }\n}\n.animate__flipInX {\n  -webkit-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n  -webkit-animation-name: flipInX;\n  animation-name: flipInX;\n}\n.flipInX {\n  animation: flipInX 2s;\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .my_current_vehicle .car_info h5 {\n    font-size: 13px;\n  }\n  .my_current_vehicle .car_info p {\n    font-size: 12px;\n  }\n  .custom_legend {\n    font-size: 13px;\n  }\n  .car_icon i {\n    font-size: 30px;\n  }\n}\n@media (min-width: 2500px) {\n  .my_current_vehicle .car_info h5 {\n    font-size: 16px;\n  }\n  .my_current_vehicle .car_info p {\n    font-size: 14px;\n  }\n  .custom_legend {\n    font-size: 16px;\n  }\n  .car_icon i {\n    font-size: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
